import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-right',
  templateUrl: './icon-arrow-right.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowRightComponent {}
